export default __webpack_public_path__ + "static/media/0121.2dbfa9cd.png";